const HERO_IMAGE =
  'https://res.cloudinary.com/dybjy1gw3/image/upload/v1769888064/Tusker_logo_bxfczv.png';

const TOURNAMENT_URL =
  'https://www.dailysportslife.com/soccer/public/tournament/4068f8a6611640c9922c4473494c52cd';

export const NAMSL_BALTIMORE_TOURNAMENT_SHARE_TOKEN = '4068f8a6611640c9922c4473494c52cd';
export const NAMSL_BALTIMORE_TUSKERS_RECAP_SLUG = 'columbus-tuskers-namsl-baltimore-2026-recap';

/** Columbus Tuskers — NAMSL Baltimore 2026 tournament recap (Aug 1–2) */
export const NAMSL_BALTIMORE_TUSKERS_RECAP_POST = {
  id: 'featured-namsl-baltimore-tuskers-recap-2026',
  slug: NAMSL_BALTIMORE_TUSKERS_RECAP_SLUG,
  clubId: '6a1b28c1a4966d6cd8a04941',
  title: 'Columbus Tuskers at NAMSL Baltimore: Four Wins and a Final-Day Battle',
  excerpt:
    'The Tuskers went unbeaten through Group C and the knockout rounds before a 1–3 final against Diamond FC Canada. Full scores, goal scorers, and top performers from the NAMSL weekend in Baltimore.',
  publishedAt: '2026-08-04T12:00:00.000Z',
  coverImageUrl: HERO_IMAGE,
  authorName: 'Daily Sports Life',
  clubName: 'Columbus Tuskers',
  blogCategory: 'sports-events',
  featured: true,
  pinned: true,
  component: 'TournamentRecapBlogArticle',
  tournamentShareToken: NAMSL_BALTIMORE_TOURNAMENT_SHARE_TOKEN,
  theme: 'club',
  photoSections: {
    teamPhotos: {
      eyebrow: 'Baltimore 2026',
      title: 'The squad in Baltimore',
      intro:
        'Photos from the NAMSL weekend — the team that went unbeaten through the group stage and knockouts. Tap any photo to enlarge.',
      altPrefix: 'Columbus Tuskers at NAMSL Baltimore',
    },
    squad: {
      eyebrow: 'Meet the team',
      title: 'Tuskers roster at NAMSL Baltimore',
      intro:
        'The players who represented Columbus at Troy Park — with tournament goals and assists where they contributed on the scoreboard. Tap a player photo to enlarge.',
    },
    awards: {
      eyebrow: 'Tournament honors',
      title: 'Individual awards',
      intro: 'Standout performers recognized from the NAMSL Baltimore weekend. Tap a photo to enlarge.',
    },
  },
  relatedPostsTitle: 'More Tuskers & NAMSL coverage',
  relatedPosts: [
    {
      slug: 'kerala-restaurants-baltimore-khiladiz-namsl-tournament',
      title: 'Best Kerala Restaurants Near Baltimore for the Khiladiz NAMSL Tournament',
      blurb: 'where to eat during tournament weekend at Troy Park.',
    },
    {
      slug: 'columbus-tuskers-live-status',
      title: 'Columbus Tuskers — Live Schedule & Results',
      blurb: 'auto-updated Tuskers fixtures and links.',
    },
    {
      slug: 'soccer-team-game-day-checklist',
      title: 'Soccer Team Game Day Checklist',
      blurb: 'match-day prep for travel tournaments.',
    },
  ],
  referenceLinks: [
    {
      label: 'Full NAMSL Baltimore scoreboard',
      url: TOURNAMENT_URL,
    },
    {
      label: 'Khiladiz — 5th Annual NAMSL Tournament',
      url: 'https://www.khiladiz.com/the-5th-annual-namsl-soccer-tournament-in-baltimore-md-on-july-31-august-2-2026/',
    },
    {
      label: 'COMA Ohio',
      url: 'https://www.comaohio.org/',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'Tournament summary',
      items: [
        { value: '4–1', label: 'Match record (W–L)' },
        { value: '11 goals', label: 'Scored in 5 matches' },
        { value: 'Runners-up', label: 'Final vs Diamond FC Canada' },
        { value: 'Aug 1–2', label: 'Baltimore, MD' },
      ],
    },
    {
      type: 'panel',
      title: 'A weekend to remember',
      paragraphs: [
        'The **Columbus Tuskers** carried Ohio pride to the **North American Malayalee Soccer League (NAMSL)** championship in Baltimore — the Khiladiz-hosted **5th Annual V. P. Sathyan Memorial Tournament** at Troy Park in Elkridge, Maryland.',
        'Over two days the Tuskers won every match through the group stage and knockout rounds: **Group C**, a **quarter-final**, and a **semi-final**. On Sunday night they met **Diamond FC Canada** in the final and fell **1–3** after a hard-fought contest.',
        'It was not the trophy we traveled for, but four wins on the road and a final appearance is a result the whole **COMA Ohio** community can be proud of. Thank you to everyone who followed the scores, cheered from Columbus, and supported the squad in Baltimore.',
      ],
      chips: ['Columbus Tuskers', 'NAMSL 2026', 'Baltimore', 'COMA Ohio', '40+'],
    },
    {
      type: 'table',
      title: 'Match results',
      intro: 'All five Tuskers fixtures from the published tournament scoreboard.',
      headers: ['Round', 'Opponent', 'Result', 'Date'],
      rows: [
        ['Group C', 'Dallas', 'Tuskers 2–1', 'Sat, Aug 1 · 2:30 PM'],
        ['Group C', 'Khiladis Baltimore', 'Tuskers 1–0', 'Sat, Aug 1 · 7:30 PM'],
        ['Quarter-final', 'MFC California', 'Tuskers 4–1', 'Sun, Aug 2 · 1:30 PM'],
        ['Semi-final', 'Dallas Dianomos', 'Tuskers 3–1', 'Sun, Aug 2 · 4:00 PM'],
        ['Final', 'Diamond FC Canada', 'Tuskers 1–3', 'Sun, Aug 2 · 9:15 PM'],
      ],
    },
    {
      type: 'panel',
      title: 'Group C — Tuskers 2–1 Dallas',
      paragraphs: [
        'The Tuskers opened the weekend with a confident win in **Group C**. **Anil Koothoor** struck in the 20th minute, set up by **Aslam Abubacker**. Aslam doubled the lead at 40′ to put the match beyond reach.',
      ],
      list: [
        "20′ **Anil Koothoor** (assist Aslam Abubacker)",
        '40′ **Aslam Abubacker**',
      ],
    },
    {
      type: 'panel',
      title: 'Group C — Tuskers 1–0 Khiladis Baltimore',
      paragraphs: [
        'Saturday evening brought a tight battle against local hosts **Khiladis Baltimore**. **Ashish** found the net in the 30th minute after a **Shibu Nair** assist — one goal was enough to seal a clean sheet and top the group momentum.',
      ],
      list: ['30′ **Ashish** (assist Shibu Nair)'],
    },
    {
      type: 'panel',
      title: 'Quarter-final — Tuskers 4–1 MFC California',
      paragraphs: [
        'Sunday afternoon the attack clicked. **Pravi** orchestrated from the front with a goal and three assists. **Subhash** finished twice, and Aslam added another — a statement win that sent the Tuskers into the semi-finals.',
      ],
      list: [
        '20′ **Aslam Abubacker** (assist Pravi)',
        '30′ **Pravi**',
        '35′ **Subhash** (assist Pravi)',
        '38′ **Subhash** (assist Pravi)',
      ],
    },
    {
      type: 'panel',
      title: 'Semi-final — Tuskers 3–1 Dallas Dianomos',
      paragraphs: [
        'The Tuskers met Dallas again in the semi-final and controlled the tie. **Pravi** and **Subhash** combined for two goals each way — Pravi with two finishes and Subhash with one — while **Dilin joy** picked up an assist on Pravi’s second.',
      ],
      list: [
        '20′ **Pravi** (assist Subhash)',
        '25′ **Pravi** (assist Dilin joy)',
        '35′ **Subhash** (assist Pravi)',
      ],
    },
    {
      type: 'panel',
      title: 'Final — Tuskers 1–3 Diamond FC Canada',
      paragraphs: [
        'Under the lights on Sunday night, **Diamond FC Canada** lifted the championship. The Tuskers drew level early through **Subhash** in the 15th minute — again assisted by **Pravi** — but Canada answered with three goals to take the title.',
        'Heartbreak in the final, but reaching the championship match after four straight wins is a run worth celebrating. The squad left Baltimore with heads held high.',
      ],
      list: ['15′ **Subhash** (assist Pravi)'],
      callout: {
        text: 'Full live scoreboard with minute-by-minute goals',
        url: TOURNAMENT_URL,
      },
    },
    {
      type: 'table',
      title: 'Top scorers & assists',
      intro: 'Tournament totals from the Tuskers roster at NAMSL Baltimore.',
      headers: ['Player', 'Goals', 'Assists'],
      rows: [
        ['Subhash', '4', '1'],
        ['Pravi', '3', '5'],
        ['Aslam Abubacker', '2', '1'],
        ['Anil Koothoor', '1', '0'],
        ['Ashish', '1', '0'],
        ['Dilin joy', '0', '1'],
        ['Shibu Nair', '0', '1'],
      ],
    },
    {
      type: 'panel',
      title: 'Thank you, Columbus',
      paragraphs: [
        `To the players, coaches, families, and **COMA Ohio** supporters who followed every kick from Baltimore — thank you. Share this recap with friends who missed the weekend, and bookmark the [live scoreboard](${TOURNAMENT_URL}) for future Tuskers tournaments.`,
        '**Next up:** stay tuned on [COMA Ohio](https://www.comaohio.org/) and the Tuskers channels for practice schedules, local league play, and the next road trip.',
      ],
    },
  ],
};
